/*
 * @Author: edvardchen
 * @Date:   2016-08-09 10:57:45
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-08-16 17:26:22
 */

/* eslint import/prefer-default-export: 0 */
/**
 * convert ratio to percent
 * @param  {Number} value
 * @return {String}
 */
export function ratioToPercent(value) {
  if (typeof value !== 'number' || value <= 0) {
    return '';
  }
  return `${(value * 100).toFixed(2)}%`;
}



// WEBPACK FOOTER //
// ./src/HTMLTag/helper.js